import { useState, useEffect } from 'react'
import axios from 'axios'
import { useAuth } from '../../Context/AuthContext'
import chatIcon from '../../Assets/Icons/customer-service.png'

/**
 * Floating support chat button + message dialog, shared across marketing
 * pages. Can be controlled externally (footer message icon) via open/setOpen.
 */
export default function SupportWidget({ open, setOpen }) {
    const { currentUser, role } = useAuth()

    const [message, setMessage] = useState('')
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [messageSent, setMessageSent] = useState(false)

    useEffect(() => {
        if (currentUser) {
            setName(currentUser.displayName || '')
            setEmail(currentUser.email || '')
        }
    }, [currentUser])

    const capitalizeFirstLetter = (string) =>
        string?.charAt(0).toUpperCase() + string?.slice(1)

    const toggleDialog = () => {
        if (!open) {
            setMessageSent(false)
        }
        setOpen(!open)
    }

    const handleSendMessage = () => {
        setMessageSent(true)

        const payload = {
            senderId: currentUser ? currentUser.uid : '',
            senderName: name,
            senderEmail: email,
            sentBy: capitalizeFirstLetter(role) || 'Unregistered',
            message,
        }

        axios
            .post(`${process.env.REACT_APP_API}/chats/open-support-chat`, payload)
            .then(() => {
                setMessage('')
                if (!currentUser) {
                    setEmail('')
                    setName('')
                }
            })
            .catch((error) => {
                setMessageSent(false)
                console.log(error)
            })
    }

    return (
        <>
            <div className="icon-container">
                <button className="icon-btn" onClick={toggleDialog}>
                    <img src={chatIcon} alt="Contact First Dance support" />
                </button>
            </div>

            {open && (
                <div className="dialog-box">
                    <div className="dialog-content">
                        <span className="dialog-title" onClick={() => setOpen(false)}>
                            How Can We Help?
                        </span>
                        <span className="close-btn" onClick={() => setOpen(false)}>
                            &times;
                        </span>

                        <div className="dialog-text">
                            Online chat is not yet available but send
                            <br />
                            us a message and we'll get back to you.
                        </div>

                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Full name"
                            className="name-input"
                            readOnly={!!currentUser?.displayName}
                        />

                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="email-input"
                            readOnly={!!currentUser?.email}
                        />

                        <div>
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Enter your message"
                                className="message-input"
                            />
                        </div>

                        {messageSent ? (
                            <div className="dialog-text">
                                Your message has been sent.
                                <br />
                            </div>
                        ) : (
                            <button
                                style={{
                                    backgroundColor: !message.trim() ? '#ccc' : '#ecbdba',
                                    color: !message.trim() ? null : '#fff',
                                    cursor: !message.trim() ? 'not-allowed' : null,
                                    opacity: !message.trim() ? 0.6 : null,
                                    borderRadius: 4,
                                    border: 'unset',
                                    padding: '5px 10px',
                                    fontWeight: 600,
                                }}
                                title={!message.trim() ? 'Type a message' : ''}
                                onClick={handleSendMessage}
                                disabled={
                                    !(!!message?.trim() && !!name?.trim() && !!email?.trim()) ||
                                    messageSent
                                }
                            >
                                Send
                            </button>
                        )}
                        <p style={{ fontSize: '10px', fontWeight: 'bold' }}>
                            Please do not include sensitive data in your message.
                        </p>
                    </div>
                </div>
            )}
        </>
    )
}
